import { memo } from 'react';
import { useSelector } from 'react-redux';

import { nbspJsString } from 'shared/constants/symbols';
import { selectIsMoscowOrMO } from 'shared/selectors/locations/selectIsMoscowOrMO';

import { About } from './About';

const MOSCOW_AND_MO = `
ПИК${nbspJsString}— технологичная компания и${nbspJsString}лидер российского девелопмента, который меняет города с${nbspJsString}1994${nbspJsString}года.

За${nbspJsString}31${nbspJsString}год${nbspJsString}мы построили 37${nbspJsString}млн${nbspJsString}м² жилья для${nbspJsString}620${nbspJsString}тысяч семей. Сегодня наши проекты реализуются в${nbspJsString}14${nbspJsString}регионах${nbspJsString}— от${nbspJsString}Москвы до${nbspJsString}Владивостока.

Наша миссия${nbspJsString}— делать городскую среду удобной, а${nbspJsString}жителей счастливыми. Каждый десятый квадратный метр в${nbspJsString}столице за${nbspJsString}последнее десятилетие построен${nbspJsString}ПИК.
ПИК${nbspJsString}— это${nbspJsString}не${nbspJsString}просто квартиры. Это${nbspJsString}новый образ жизни.
`.trim();

const OTHER_REGIONS = `
ПИК${nbspJsString}— ведущий девелопер страны, который с${nbspJsString}1994${nbspJsString}года меняет облик городской среды.

За${nbspJsString}31${nbspJsString}год${nbspJsString}работы мы${nbspJsString}построили свыше 37${nbspJsString}млн${nbspJsString}м² жилья, где${nbspJsString}сейчас проживает более 620 000${nbspJsString}семей. Сейчас реализует проекты в${nbspJsString}14${nbspJsString}регионах страны.

Миссия девелопера${nbspJsString}— делать города удобными и${nbspJsString}комфортными для${nbspJsString}жизни, а${nbspJsString}жителей городов счастливыми. ПИК${nbspJsString}создаёт комфортные районы с${nbspJsString}развитой инфраструктурой: школы с${nbspJsString}досуговыми центрами, детсады с${nbspJsString}бассейнами, спортивные площадки и${nbspJsString}зоны отдыха. Покупая квартиру в${nbspJsString}ПИК, жители получают не${nbspJsString}просто жильё, а${nbspJsString}новый образ жизни.
`.trim();

export const AboutContainer = memo(function AboutContainer() {
  const isMoscowOrMO = useSelector(selectIsMoscowOrMO);

  const contentText = isMoscowOrMO ? MOSCOW_AND_MO : OTHER_REGIONS;

  return <About contentText={contentText} sectionTabTitle="О компании" title="О компании" />;
});
